var __WEBPACK_NAMESPACE_OBJECT__ = require("@processmaker/screen-builder");